import JSZip from "jszip";
import { getAds, downloadMedia } from "./ads-state.js";

function deriveMediaFile(adId, mediaPath) {
  if (!mediaPath) return null;
  // Storage'da "1700000000-promo.mp4" gibi bir path; bunu media/<original> olarak ZIP'e koy.
  const base = mediaPath.split("/").pop();
  // Çakışma olmasın diye id prefix ekle
  return `media/${adId}-${base}`;
}

export async function exportZip() {
  const ads = getAds();
  if (ads.length === 0) {
    throw new Error("Aktarılacak reklam yok");
  }

  const zip = new JSZip();
  const mediaFolder = zip.folder("media");
  const manifestAds = [];

  for (const ad of ads) {
    let mediaFile = null;
    if (ad.media_path) {
      mediaFile = deriveMediaFile(ad.id, ad.media_path);
      try {
        const blob = await downloadMedia(ad.media_path);
        const arrBuf = await blob.arrayBuffer();
        mediaFolder.file(mediaFile.replace(/^media\//, ""), arrBuf);
      } catch (err) {
        console.warn(`Medya indirilemedi: ${ad.id}`, err);
        mediaFile = null;
      }
    }

    manifestAds.push({
      id: ad.id,
      title: ad.title,
      media_file: mediaFile,
      media_type: ad.media_type,
      orientation: ad.orientation || "any",
      duration_sec: ad.duration_sec,
      age_brackets: ad.age_brackets || [],
      genders: ad.genders || [],
      group_types: ad.group_types || [],
      priority: ad.priority ?? 5,
      start_hour: ad.start_hour ?? 0,
      end_hour: ad.end_hour ?? 24,
      enabled: ad.enabled !== false,
      max_impressions_per_day: ad.max_impressions_per_day ?? null,
    });
  }

  const manifest = {
    schema_version: 1,
    exported_at: new Date().toISOString(),
    ads: manifestAds,
  };
  zip.file("manifest.json", JSON.stringify(manifest, null, 2));

  const blob = await zip.generateAsync({ type: "blob", compression: "DEFLATE" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const ts = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  a.href = url;
  a.download = `adwise-export-${ts}.zip`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);

  return { count: manifestAds.length };
}
